import { createUID, Status } from '@pega/cosmos-react-core';

const createDate = new Date(2016, 1, 8);
const msInYear = 1000 * 60 * 60 * 24 * 365;
const diffInYears = Math.floor((Date.now() - createDate.getTime()) / msInYear);

const baseSecondaryFields = [
  {
    name: 'Status',
    value: <Status variant='info'>New</Status>
  },
  {
    name: 'Assigned to',
    value: 'Dean Thomas'
  },
  {
    name: 'Create date',
    value: createDate.toDateString()
  },
  {
    name: 'Update date',
    value: `${diffInYears} years ago`
  }
];

export const casePreviewPrimaryFields = [
  {
    name: 'Member ID',
    value: 'M204859F438G'
  },
  {
    name: 'Priority',
    value: '95'
  }
];

export const casePreviewSecondaryFields = baseSecondaryFields;

export const getPromotedActions = (count: number) => {
  return [
    {
      id: createUID(),
      text: 'Reassign',
      onClick: () => {}
    },
    {
      id: createUID(),
      text: 'Add dependency',
      onClick: () => {}
    },
    {
      id: createUID(),
      text: 'Clone',
      onClick: () => {}
    },
    {
      id: createUID(),
      text: 'Move',
      onClick: () => {}
    },
    {
      id: createUID(),
      text: 'Withdraw',
      onClick: () => {}
    },
    {
      id: createUID(),
      text: 'Approve',
      onClick: () => {}
    },
    {
      id: createUID(),
      text: 'Reject',
      onClick: () => {}
    },
    {
      id: createUID(),
      text: 'Delegate',
      onClick: () => {}
    },
    {
      id: createUID(),
      text: 'Escalate',
      onClick: () => {}
    },
    {
      id: createUID(),
      text: 'Cancel',
      onClick: () => {}
    }
  ].slice(0, count);
};
